import r from "@ui-components-3/icons/lib/regular/SlashForward";

import { COLOR_VARIANTS as o } from "../../../constants/index.js";

import { createContext as a } from "react";

const t = r, i = a({
    Separator: t,
    separatorClassName: "",
    Link: null,
    variant: o.primary
});

export { i as AppBarContext, t as DefaultSeparator };
//# sourceMappingURL=index.js.map
